import { NgModule } from '@angular/core'
import { HubTranslatePipe } from './hub-translate.pipe'

@NgModule({
  declarations: [
    HubTranslatePipe
  ],
  exports: [
    HubTranslatePipe
  ]
})
export class HubSharedTranslateModule { }
